import { IValidateCustomerDocumentRepository } from 'modules/authentication/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisValidateCustomerDocumentRepository from './implementations/VectisValidateCustomerDocumentRepository';

let instance: IValidateCustomerDocumentRepository | null = null;

export default function makeValidateCustomerDocumentRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisValidateCustomerDocumentRepository(httpProvider);
  }

  return instance;
}
